import React from 'react';
import { Box, Typography, Chip, Stack, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * Component to display the keys from the singleValueKeys map using Accordions.
 * @param {Object} props - The component props.
 * @param {Map<string, boolean>} props.singleValueKeys - The map containing keys that correspond to single values in the filter.
 * @param {Object} props.filter - The filter object containing the actual values.
 * @returns {JSX.Element}
 */
const SingleValueKeysDisplay = ({ singleValueKeys, filter }) => { // Added filter prop
  const keys = Array.from(singleValueKeys.keys());

  if (keys.length === 0) {
    return null; // Don't render anything if there are no single value keys
  }

  // Helper function to format the value for display
  const formatValue = (value) => {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (value === null || value === undefined || value === '') {
      return 'Not specified';
    }
    return String(value);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
        Single Value Filters:
      </Typography>
      {keys.map((key) => (
        <Accordion key={key} sx={{ '&.Mui-expanded:first-of-type': { marginTop: 0 }, '&:before': { display: 'none' }, border: '1px solid rgba(0, 0, 0, .125)', boxShadow: 'none' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${key}-content`}
            id={`${key}-header`}
            sx={{ minHeight: '40px', '& .MuiAccordionSummary-content': { marginY: '8px' } }}
          >
            {/* Capitalize key and add space before caps */}
            <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>{key.replace(/([A-Z])/g, ' $1')}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0, pb: 1, px: 2 }}>
            <Chip label={formatValue(filter[key])} size="small" />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default SingleValueKeysDisplay;
